import { OfferField } from '../models';

export const offerLabels = <Record<OfferField, string>>{
  [OfferField.Name]: 'Name',
  [OfferField.Url]: 'Url',
  [OfferField.Urls]: 'Url',
  [OfferField.User]: 'User',
  [OfferField.CntLimit]: 'Cnt Limit',
  [OfferField.DayCntLimit]: 'Day Cnt Limit',
  [OfferField.SumLimit]: 'Sum Limit',
  [OfferField.DaySumLimit]: 'Day Sum Limit',
  [OfferField.UnicCnt]: 'Uniqueness',
  [OfferField.Timeout]: 'Timeout',
  [OfferField.ProposalProbability]: 'Proposal probability',
  [OfferField.PostbackUrl]: 'Postback Url',
  [OfferField.OfferGeos]: 'Offer geo',
  [OfferField.Partner]: 'Partner',
  [OfferField.TrafficSource]: 'Traffic source',
  [OfferField.Subid]: 'Subid',
  [OfferField.TargetGender]: 'Gender',
  [OfferField.TargetAge]: 'Age',

  [OfferField.DeviceVendor]: 'Device vendor',
  [OfferField.DeviceModel]: 'Device model',
  [OfferField.PriceType]: 'Price type',
  [OfferField.PriceRange]: 'Custom price range',

  [OfferField.AndroidVersion]: 'Android version',
  [OfferField.Browser]: 'Browser type',
  [OfferField.Messenger]: 'Check App',
  [OfferField.Apps]: 'Check App',
  [OfferField.Language]: 'Language',
  [OfferField.Categories]: 'Category',
  [OfferField.SubCategories]: 'Sub Category',
};
